var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 112,
    viewBox: "0 0 118 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 43.33C71.0812 43.33 62.5612 42.99 54.5912 40.77C46.7712 38.6 39.5912 34.39 33.1912 29.52C29.0012 26.35 25.1912 23.83 19.7512 24.21C14.4247 24.5016 9.3336 26.5002 5.23121 29.91C-1.68879 35.91 -0.648793 47.14 2.12121 55.03C6.28121 66.91 18.9412 75.14 29.7012 80.52C42.1312 86.73 55.7912 90.33 69.4812 92.41C81.4812 94.23 96.9012 95.56 107.301 87.72C116.851 80.52 119.471 64.08 117.131 52.98C116.564 49.6979 114.818 46.7358 112.221 44.65C105.511 39.75 95.5012 43.02 87.9612 43.19C85.1612 43.25 82.3112 43.32 79.4512 43.33Z",
    fill: "#3B0069",
    fillOpacity: 0.37
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9712 111.86C79.2456 111.86 95.6812 110.835 95.6812 109.57C95.6812 108.305 79.2456 107.28 58.9712 107.28C38.6969 107.28 22.2612 108.305 22.2612 109.57C22.2612 110.835 38.6969 111.86 58.9712 111.86Z",
    fill: "#3B0069",
    fillOpacity: 0.37
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9812 2.53007C81.5225 2.53007 81.9612 2.09131 81.9612 1.55007C81.9612 1.00883 81.5225 0.570068 80.9812 0.570068C80.44 0.570068 80.0012 1.00883 80.0012 1.55007C80.0012 2.09131 80.44 2.53007 80.9812 2.53007Z",
    fill: "#3B0069"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3313 86.11C17.8726 86.11 18.3113 85.6713 18.3113 85.13C18.3113 84.5888 17.8726 84.15 17.3313 84.15C16.7901 84.15 16.3513 84.5888 16.3513 85.13C16.3513 85.6713 16.7901 86.11 17.3313 86.11Z",
    fill: "#3B0069"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7512 1.96C32.2925 1.96 32.7312 1.52124 32.7312 0.98C32.7312 0.43876 32.2925 0 31.7512 0C31.21 0 30.7712 0.43876 30.7712 0.98C30.7712 1.52124 31.21 1.96 31.7512 1.96Z",
    fill: "#3B0069"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.581 38.69C110.123 38.69 110.561 38.2512 110.561 37.71C110.561 37.1687 110.123 36.73 109.581 36.73C109.04 36.73 108.601 37.1687 108.601 37.71C108.601 38.2512 109.04 38.69 109.581 38.69Z",
    fill: "#3B0069"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2112 93.1V97.41",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0513 95.26H57.3613",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8113 19.9301V24.2401",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6514 22.0901H100.961",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3914 13.86V18.17",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2412 16.01H51.5412",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6214 46.1301C31.9171 46.1301 37.8314 40.2158 37.8314 32.9201C37.8314 25.6244 31.9171 19.7101 24.6214 19.7101C17.3257 19.7101 11.4114 25.6244 11.4114 32.9201C11.4114 40.2158 17.3257 46.1301 24.6214 46.1301Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6212 42.5401C29.9342 42.5401 34.2412 38.233 34.2412 32.92C34.2412 27.6071 29.9342 23.3 24.6212 23.3C19.3082 23.3 15.0012 27.6071 15.0012 32.92C15.0012 38.233 19.3082 42.5401 24.6212 42.5401Z",
    fill: "#3B0069",
    fillOpacity: 0.78
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3613 39.12L24.3013 37.6C23.4869 37.6284 22.6806 37.4312 21.9713 37.03L22.2913 36.03C22.9512 36.4269 23.7116 36.6248 24.4813 36.6C25.5513 36.6 26.2513 35.91 26.2113 35.05C26.1713 34.19 25.5713 33.73 24.4413 33.33C22.8813 32.79 21.9113 32.13 21.8613 30.82C21.8468 30.2069 22.061 29.6104 22.4621 29.1464C22.8632 28.6825 23.4225 28.3844 24.0313 28.31L23.9713 26.79H24.9013L24.9613 28.25C25.6554 28.2269 26.3439 28.3819 26.9613 28.7L26.6213 29.7C26.0363 29.3829 25.3761 29.2308 24.7113 29.26C23.5513 29.31 23.1413 30.02 23.1613 30.62C23.1613 31.4 23.7713 31.77 25.1013 32.26C26.6713 32.83 27.4813 33.58 27.5413 34.92C27.5541 35.5649 27.3286 36.1919 26.9079 36.6809C26.4872 37.1699 25.9009 37.4865 25.2613 37.57L25.3213 39.14L24.3613 39.12Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7912 75.32L38.7212 87.64C37.7485 87.8831 36.7331 87.9013 35.7523 87.6934C34.7714 87.4854 33.8509 87.0567 33.0605 86.4398C32.27 85.8229 31.6306 85.034 31.1906 84.133C30.7506 83.232 30.5217 82.2427 30.5212 81.24V28.29L85.9112 14.39C86.4829 14.2473 87.0795 14.2366 87.6558 14.3588C88.2322 14.4809 88.7732 14.7328 89.2377 15.0951C89.7023 15.4575 90.0782 15.9209 90.337 16.4502C90.5957 16.9795 90.7306 17.5608 90.7312 18.15V71.57C90.7298 72.4335 90.4396 73.2716 89.9068 73.9511C89.3741 74.6307 88.6294 75.1125 87.7912 75.32Z",
    fill: "#3B0069",
    fillOpacity: 0.78
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5212 28.64H99.7912C100.299 28.64 100.803 28.7401 101.272 28.9346C101.742 29.1291 102.168 29.4141 102.528 29.7735C102.887 30.1329 103.172 30.5595 103.367 31.029C103.561 31.4986 103.661 32.0018 103.661 32.51V86.17C103.661 86.6782 103.561 87.1815 103.367 87.651C103.172 88.1205 102.887 88.5472 102.528 88.9065C102.168 89.2659 101.742 89.5509 101.272 89.7454C100.803 89.9399 100.299 90.04 99.7912 90.04H35.1812C33.9453 90.04 32.76 89.549 31.8861 88.6751C31.0122 87.8012 30.5212 86.6159 30.5212 85.38V28.64Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9114 63.6201C96.2751 63.6201 98.1914 61.7038 98.1914 59.3401C98.1914 56.9763 96.2751 55.0601 93.9114 55.0601C91.5476 55.0601 89.6313 56.9763 89.6313 59.3401C89.6313 61.7038 91.5476 63.6201 93.9114 63.6201Z",
    fill: "#3B0069",
    fillOpacity: 0.78
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletEmpty);
export default __webpack_public_path__ + "static/media/WalletEmpty.7dd8d5aacfbf8092334f291a5e132a2e.svg";
export { ForwardRef as ReactComponent };